const SUPPORT_EMAIL = "contact@medlyai.com";

function getBrowserName(): string {
  const ua = navigator.userAgent;
  if (ua.includes("Edg/")) return "Edge";
  if (ua.includes("OPR/") || ua.includes("Opera")) return "Opera";
  if (ua.includes("Chrome/") && !ua.includes("Edg/")) return "Chrome";
  if (ua.includes("Safari/") && !ua.includes("Chrome/")) return "Safari";
  if (ua.includes("Firefox/")) return "Firefox";
  return ua;
}

export function openContactSupport({
  name,
  email,
  platform,
}: {
  name: string;
  email: string;
  platform: string;
}) {
  const browser = getBrowserName();
  const deviceType = /Mobi|Android/i.test(navigator.userAgent)
    ? "Mobile"
    : "Desktop";
  const subject = encodeURIComponent("Support Request");
  const body = encodeURIComponent(
    `\n\n---\nName: ${name}\nEmail: ${email}\nPlatform: ${platform}\nPage: ${window.location.href}\nBrowser: ${browser}\nDevice Type: ${deviceType}`
  );
  window.open(
    `mailto:${SUPPORT_EMAIL}?subject=${subject}&body=${body}`,
    "_self"
  );
}
